import { useTranslation } from 'react-i18next'

import { OuiSenseIcon } from '@/icons'

export default function DefaultErrorComponent({ error }: { error: unknown }) {
  const { t } = useTranslation()
  console.error(error)

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <OuiSenseIcon fill="red" className="size-16" />
      <span>{t('anErrorOccured')}</span>
    </div>
  )
}
